/**
 * Constantes pour le module MouvementsOrList
 */

export const TAB_INDICES = {
  CLAL: 0,
  FOURNISSEURS: 1,
  CLIENTS: 2
};

export const SOURCE_TYPES = {
  CLAL: 'CLAL',
  FOURNISSEUR: 'FOUR',
  CLIENT: 'CLI'
};

export const METAL_IDS = {
  OR: '1'
};

export const COURS_IDS = {
  PERTE_CLIENT: '14',
  VIEIL_OR: '15'
};

export const PAGINATION_OPTIONS = [10, 25, 50, 100];

export const DEFAULT_ROWS_PER_PAGE = 25;

// Constantes pour les calculs
export const OR_750_TO_FIN_RATIO = 0.75;
